import { FC, memo } from 'react';
import styled from 'styled-components';
import { ReactComponent as OrderPageBanner } from '../../../assets/images/banners/ban2.svg';
import { useAppSelector } from '../../../store/hooks';
import { Container } from '../../../styles/container.styled';
import { StyledSection } from '../../../styles/section.styled';
import CustomMap from '../../UI/CustomMap/CustomMap';
import OrderForm from '../../UI/OrderForm/OrderForm';
import PageTitle from '../../UI/PageTitle/PageTitle';

const OrderPage: FC = () => {
    const isRent = useAppSelector((state) => state.main.isRent);
    return (
        <StyledOrderPage>
            <StyledSection>
                <Container>
                    <PageTitle
                        title="Особенное такси"
                        subTitle="Комфортная и безопасная перевозка пассажиров-колясочников по Санкт-Петербургу и Ленинградской области"
                    />
                    <StyledOrderPageWrapper>
                        <OrderForm />
                        {!isRent ? <CustomMap /> : <StyledOrderPageBanner />}
                    </StyledOrderPageWrapper>
                </Container>
            </StyledSection>
        </StyledOrderPage>
    );
};

const StyledOrderPageBanner = memo(styled(OrderPageBanner)`
    width: 100%;
    height: 100%;
    object-fit: cover;
`);

const StyledOrderPage = memo(styled.div``);

const StyledOrderPageWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    margin-top: 48px;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
        gap: 32px;
        margin-top: 32px;
    }
`;

export default OrderPage;

